<!-- 



        this component receives tabs as a prop -
            1) single date
            2) multiple dates / options
            3) date range

        1 and 2 are the regular calendar (PlanupCalendar - the items, the month navigation); in 2 a
        click on a day chooses it or takes it back, and optionDates (the event's current options)
        are chosen when the modal opens

        optionRange (an undated event's requestedDateRange) is loaded into 3 the same way: the modal
        opens on the tab of what the event holds, and the field shows the options / range under it.
        המשך applies tab 2 / 3 only when it changed since the modal opened, so a look at a tab never
        clears the event's date (the customer page's events have one).




-->


<template>
    <div style="position:relative;">


        <div style="display:flex;align-items:center;">
            <div style="position:relative;flex:1;min-width:0;">
                <input class="form-control"
                       ref="dateInput"
                       :style="dayLabelReserve ? ('padding-left:' + dayLabelReserve + 'px') : ''"
                       v-model="textToShowInForm"
                       placeholder="DD/MM/YYYY"
                       @keydown.enter="parseTypedDate"
                       @blur="parseTypedDate"
                       @input="autoSlash">
                <span v-if="dayOfWeekLabel && dayLabelReserve"
                      style="position:absolute;top:50%;transform:translateY(-50%);left:10px;font-size:13px;color:#888;white-space:nowrap;pointer-events:none;">
                    {{ dayOfWeekLabel }}
                </span>
            </div>
            <button type="button"
                    class="btn btn-primary"
                    style="margin-right:4px;padding:6px 10px;"
                    @click="openModal()">
                <i class="fa-regular fa-calendar"></i>
            </button>
        </div>

        <!-- the options / range the event holds instead of a date; a click opens the picker on them -->
        <div v-if="requestedSummary"
             class="edpRequested"
             @click="openModal()">
            <i class="fa-regular fa-calendar-check"></i>
            <span>{{ requestedSummary }}</span>
        </div>



        <!-- <button class="btn btn-primary ms-1"
                @click="openModal()">
            פתח יומן
            &nbsp;
            <i class="fa-regular fa-calendar"></i>
        </button> -->


        <Modal title="בחירת תאריך לאירוע"
               ref="EventDatePickerModal"
               :hideHeader="true"
               :xlarge="true">

            <template v-slot:body>


                <div v-if="tabs && tabs.length > 1"
                     class="yonsoTabsWrapper">


                    <div v-if="tabs.includes(1)"
                         class="yonsoTab"
                         :class="{ active: activeTab == 1 }"
                         @click="setActiveTab(1)">
                        <label>
                            תאריך ידוע
                        </label>
                    </div>

                    <div v-if="tabs.includes(2)"
                         class="yonsoTab"
                         :class="{ active: activeTab == 2 }"
                         @click="setActiveTab(2)">
                        <label>
                            מספר אפשרויות
                        </label>
                    </div>

                    <div v-if="tabs.includes(3)"
                         class="yonsoTab"
                         :class="{ active: activeTab == 3 }"
                         @click="setActiveTab(3)">
                        <label>
                            טווח תאריכים
                        </label>
                    </div>

                </div>


                <div v-if="tabs.includes(1)"
                     v-show="activeTab == 1"
                     style="text-align: center;">


                    <h5 style="text-align: right;">


                        בחרו את התאריך שהלקוח מבקש
                    </h5>



                    <div class="planupCalendarWrapper">

                        <PlanupCalendar :showTodayAgendaOnPopup="false"
                                        :confirmDateOnClick="true"
                                        :disableClickDatePopup="true"
                                        :hideDisplayTypeSelector="true"
                                        ref="singleDateCalendar"
                                        :disableItemClicks="true"
                                        @chooseDate="chooseDate($event)"
                                        @chooseTime="chooseTime($event)">
                        </PlanupCalendar>

                    </div>

                    <!-- <calendar-view :timeFormatOptions="{ hour: 'numeric', minute: 'numeric' }"
                                   display-period-uom="month"
                                   :displayPeriodCount="1"
                                   :items="calendarItems"
                                   @click-date="clickDate_singleDate"
                                   :style="'height:700px!important'"
                                   class="theme-default">

                        <template #dayContent="h">
                            <div v-html="$globals.hebrewDateDay(h.day)"
                                 class="cv-date-heb"></div>
                        </template>

</calendar-view> -->

                </div>

                <div v-if="tabs.includes(2)"
                     v-show="activeTab == 2"
                     style="text-align: center;">

                    <h5 style="text-align: right;">
                        סמנו את התאריכים שהלקוח מעוניין בהם
                        <span style="font-size:13px;font-weight:normal;color:#999;">
                            (לחיצה נוספת על יום מבטלת אותו)
                        </span>
                    </h5>

                    <div v-if="placeHolder"
                         class="edpNote">
                        לאירוע נקבע תאריך ({{ placeHolder }}) - האפשרויות שתסמנו יחליפו אותו
                    </div>


                    <div class="planupCalendarWrapper">

                        <PlanupCalendar :showTodayAgendaOnPopup="false"
                                        :disableClickDatePopup="true"
                                        :hideDisplayTypeSelector="true"
                                        ref="multipleOptionsCalendar"
                                        :disableItemClicks="true"
                                        :selectedDates="specificRequestedTimestamps"
                                        @chooseDate="clickDate_multipleOptions($event)">
                        </PlanupCalendar>

                    </div>

                    <div class="edpChosenDates">
                        תאריכים שנבחרו:

                        <span v-if="!specificRequestedTimestamps.length"
                              style="color:#999;">
                            עדיין לא נבחרו תאריכים
                        </span>

                        <!-- a click shows its month; the x takes it back -->
                        <span v-for="t in sortedRequestedTimestamps"
                              :key="t"
                              class="edpChosenDate"
                              @click="showOptionMonth(t)">
                            יום {{ $globals.dayOfWeekHebrew(new Date(t)) }}
                            {{ $globals.niceDate(new Date(t)) }}
                            <i class="fa-solid fa-xmark"
                               title="ביטול התאריך"
                               @click.stop="clickDate_multipleOptions(new Date(t))"></i>
                        </span>
                    </div>

                </div>

                <div v-if="tabs.includes(3)"
                     v-show="activeTab == 3"
                     style="text-align: center;"
                     class="hideFlatpickr">


                    <h5 style="text-align: right;">
                        בחרו את טווח התאריכים שהלקוח מעוניין בו
                    </h5>

                    <div v-if="placeHolder"
                         class="edpNote">
                        לאירוע נקבע תאריך ({{ placeHolder }}) - הטווח שתבחרו יחליף אותו
                    </div>


                    <DatePicker v-model="rangeStart"
                                ref="DatePickerStart"
                                :enableTime="false"
                                :onDayCreate="fillDatePickrRange"
                                :inline="true"></DatePicker>

                    <DatePicker v-model="rangeEnd"
                                ref="DatePickerEnd"
                                :onDayCreate="fillDatePickrRange"
                                :enableTime="false"
                                :inline="true"></DatePicker>

                    <div style="text-align: right;">
                        הטווח שנבחר:

                        <span v-if="rangeStart">
                            {{ rangeStart }}
                        </span>

                        -

                        <span v-if="rangeEnd">
                            {{ rangeEnd }}

                        </span>



                    </div>

                    <div>



                        <div style="text-align: right;user-select: none;">

                            ימים בשבוע:

                            &nbsp;

                            <label>
                                <input type="checkbox"
                                       v-model="rangeDaysOfWeek.sun">
                                א'
                            </label>

                            &nbsp;


                            <label>
                                <input type="checkbox"
                                       v-model="rangeDaysOfWeek.mon">
                                ב'
                            </label>

                            &nbsp;

                            <label>
                                <input type="checkbox"
                                       v-model="rangeDaysOfWeek.tue">
                                ג'
                            </label>

                            &nbsp;

                            <label>
                                <input type="checkbox"
                                       v-model="rangeDaysOfWeek.wed">
                                ד'
                            </label>

                            &nbsp;


                            <label>
                                <input type="checkbox"
                                       v-model="rangeDaysOfWeek.thu">
                                ה'
                            </label>

                            &nbsp;

                            <label>
                                <input type="checkbox"
                                       v-model="rangeDaysOfWeek.fri">
                                ו'
                            </label>

                            &nbsp;

                            <label>
                                <input type="checkbox"
                                       v-model="rangeDaysOfWeek.sat">
                                ש'
                            </label>




                        </div>



                    </div>

                </div>








            </template>

            <template v-slot:buttons>
                <button @click="emitDates()"
                        type="button"
                        class="btn btn-primary"
                        data-bs-dismiss="modal">
                    {{ $t('continue') }}
                </button>
            </template>



        </Modal>
    </div>
</template>
<script>


import PlanupCalendar from '../Calendar/PlanupCalendar.vue';
import DatePicker from '../Common/DatePicker';
import Calendar from '../Calendar/Calendar';

// the range tab's checkboxes and the letters requestedDateRange.daysOfWeek keeps, in week order
const RANGE_DAYS = [['sun', 'א'], ['mon', 'ב'], ['tue', 'ג'], ['wed', 'ד'], ['thu', 'ה'], ['fri', 'ו'], ['sat', 'ש']];

// the event's options as the timestamps of their local midnights, sorted: they are stored at local
// midnight as UTC strings - read as a Date, never sliced
function optionTimestamps(values) {
    let timestamps = [];
    (values || []).forEach(value => {
        let date = new Date(value);
        if (!value || isNaN(date.getTime()))
            return;
        date.setHours(0, 0, 0, 0);
        if (!timestamps.includes(date.valueOf()))
            timestamps.push(date.valueOf());
    });
    return timestamps.sort((a, b) => a - b);
}

// a d/m/Y string of the range tab as a Date (null for no date)
function dmyToDate(value) {
    let parts = String(value || '').split('/');
    return parts.length == 3 ? new Date(parts[2], parts[1] - 1, parts[0]) : null;
}

export default {
    name: 'EventDatePicker',
    data() {
        return {
            activeTab: this.tabs[0],
            specificRequestedTimestamps: [],
            rangeDaysOfWeek: {},
            rangeStart: null,
            rangeEnd: null,
            textToShowInForm: this.placeHolder,
            dayLabelReserve: 0,
            // tabs 2 / 3 as the modal opened (currentChoice): המשך applies only a change
            openedWith: null,
        }
    },
    mounted() {
        this.updateDayLabelReserve();
        if (window.ResizeObserver) {
            this._dayLabelResizeObserver = new ResizeObserver(() => this.updateDayLabelReserve());
            this._dayLabelResizeObserver.observe(this.$refs.dateInput);
        } else {
            window.addEventListener('resize', this.updateDayLabelReserve);
        }
    },
    beforeDestroy() {
        if (this._dayLabelResizeObserver)
            this._dayLabelResizeObserver.disconnect();
        window.removeEventListener('resize', this.updateDayLabelReserve);
    },
    watch: {
        //not sure this is the correct way to do this
        placeHolder(newVal) {
            this.textToShowInForm = newVal;
        },

        dayOfWeekLabel() {
            this.updateDayLabelReserve();
        },

        // (null when the modal opens on an event without a range)
        rangeStart(newValue) {

            this.rangeStartDateObj = dmyToDate(newValue);
            this.redrawRangePickers();

        },

        rangeEnd(newValue) {

            this.rangeEndDateObj = dmyToDate(newValue);
            this.redrawRangePickers();

        },
    },
    computed: {
        dayOfWeekLabel() {
            // only for a complete date, so a partially-typed value doesn't flash a wrong day
            if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(this.textToShowInForm || ''))
                return '';
            return this.$globals.dayOfWeekHebrew(this.textToShowInForm);
        },

        sortedRequestedTimestamps() {
            return this.specificRequestedTimestamps.slice().sort((a, b) => a - b);
        },

        // what the event holds instead of a date, under the field - in the words of the customer page's strip
        requestedSummary() {

            if (this.placeHolder)
                return '';

            let dates = optionTimestamps(this.optionDates);

            if (dates.length)
                return (dates.length == 1 ? 'תאריך אופציונלי: ' : 'תאריכים אופציונליים: ') + dates.map(t => this.$globals.niceDate(new Date(t))).join(', ');

            let range = this.optionRange;

            if (range && range.rangeStart) {
                let text = 'טווח מבוקש: ' + range.rangeStart + (range.rangeEnd ? ' - ' + range.rangeEnd : '');
                if (Array.isArray(range.daysOfWeek) && range.daysOfWeek.length)
                    text += ' (ימים ' + range.daysOfWeek.join(', ') + ')';
                return text;
            }

            return '';
        },
    },
    props: {
        placeHolder: { type: String },
        tabs: {
            type: Array,
            required: true
        },
        // the event's current options (an undated event's specificRequestedDates)
        optionDates: {
            default: () => []
        },
        // the event's current range (an undated event's requestedDateRange: rangeStart / rangeEnd d/m/Y, daysOfWeek)
        optionRange: {
            default: () => ({})
        },
        justDateNoTime: {
            default: false,
        }
    },
    methods: {


        // show the day-of-week label only when the input is wide enough to fit it
        // next to the full date — otherwise the two texts paint over each other
        updateDayLabelReserve() {
            this.$nextTick(() => {
                let input = this.$refs.dateInput;
                if (!input || !this.dayOfWeekLabel) {
                    this.dayLabelReserve = 0;
                    return;
                }
                let cs = getComputedStyle(input);
                if (!this._measureCtx)
                    this._measureCtx = document.createElement('canvas').getContext('2d');
                this._measureCtx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
                let dateWidth = this._measureCtx.measureText(this.textToShowInForm).width;
                this._measureCtx.font = '13px ' + cs.fontFamily;
                let labelWidth = this._measureCtx.measureText(this.dayOfWeekLabel).width;
                let reserve = Math.ceil(labelWidth) + 16; // 10px left offset + gap before the date
                let fits = input.clientWidth - parseFloat(cs.paddingRight) - dateWidth - reserve >= 0;
                this.dayLabelReserve = fits ? reserve : 0;
            });
        },


        fillDatePickrRange(dObj, dStr, fp, dayElem) {


            if (!this.rangeStartDateObj || !this.rangeEndDateObj)
                return;

            if (dayElem.dateObj > this.rangeStartDateObj && dayElem.dateObj < this.rangeEndDateObj) {
                dayElem.classList.add('insidePlanupRange')
            }

        },

        chooseTime($event) {

            this.$emit('setTime', $event ? `${$event.toString().length > 1 ? $event : '0' + $event}:00` : null);
            this.$refs.EventDatePickerModal.hide();
        },


        autoSlash() {
            var val = this.textToShowInForm || '';
            var digits = val.replace(/[^0-9]/g, '');
            var formatted = '';
            for (var i = 0; i < digits.length && i < 8; i++) {
                if (i === 2 || i === 4) formatted += '/';
                formatted += digits[i];
            }
            // Add trailing slash right after 2nd or 4th digit
            if (digits.length === 2 || digits.length === 4) {
                formatted += '/';
            }
            if (formatted !== val) {
                this.textToShowInForm = formatted;
            }
        },

        parseTypedDate() {
            var text = (this.textToShowInForm || '').trim();
            if (!text) return;

            // Accept DD/MM/YYYY or D/M/YYYY
            var parts = text.split('/');
            if (parts.length !== 3) return;

            var day = parseInt(parts[0], 10);
            var month = parseInt(parts[1], 10);
            var year = parseInt(parts[2], 10);

            if (isNaN(day) || isNaN(month) || isNaN(year)) return;
            if (day < 1 || day > 31 || month < 1 || month > 12 || year < 2000) return;

            var date = new Date(year, month - 1, day);
            // Validate the date is real (e.g. not Feb 30)
            if (date.getDate() !== day || date.getMonth() !== month - 1 || date.getFullYear() !== year) return;

            this.textToShowInForm = this.$globals.niceDate(date);
            this.$emit('singleDate', date);
        },

        chooseDate($event) {

            if (!this.justDateNoTime) {
                this.$refs.singleDateCalendar.singleDayViewDate = $event;
                this.$refs.singleDateCalendar.setDayView();
            }

            // this.$refs.EventDatePickerModal.hide();
            this.textToShowInForm = this.$globals.niceDate($event);
            this.$emit('singleDate', $event)

            if (this.justDateNoTime) {
                this.closeModal();
            }

        },

        clickDate_multipleOptions(day) {

            let date = new Date(day);
            date.setHours(0, 0, 0, 0);

            let dayTimestamp = date.valueOf();
            let index = this.specificRequestedTimestamps.indexOf(dayTimestamp);

            if (index == -1) {

                this.specificRequestedTimestamps.push(dayTimestamp);

            } else {

                this.specificRequestedTimestamps.splice(index, 1);
            }
        },

        showOptionMonth(timestamp) {
            if (this.$refs.multipleOptionsCalendar)
                this.$refs.multipleOptionsCalendar.goToDate(new Date(timestamp));
        },

        // the modal opens on what the event holds: its options chosen, at the month of the first one, or
        // its range (optionRange) on the range tab - else on the first tab
        loadOptionDates() {

            if (this.tabs.includes(2))
                this.specificRequestedTimestamps = optionTimestamps(this.optionDates);

            let range = this.tabs.includes(3) && this.optionRange && this.optionRange.rangeStart ? this.optionRange : null;

            if (this.tabs.includes(3)) {
                let days = range && Array.isArray(range.daysOfWeek) ? range.daysOfWeek : [];
                let rangeDays = {};
                RANGE_DAYS.forEach(day => {
                    if (days.indexOf(day[1]) > -1)
                        rangeDays[day[0]] = true;
                });
                this.rangeStart = range ? range.rangeStart : null;
                this.rangeEnd = range ? range.rangeEnd || null : null;
                this.rangeDaysOfWeek = rangeDays;
            }

            if (this.tabs.includes(2) && this.specificRequestedTimestamps.length) {
                this.activeTab = 2;
                this.showOptionMonth(this.sortedRequestedTimestamps[0]);
            } else if (range) {
                this.activeTab = 3;
            } else {
                this.activeTab = this.tabs[0];
            }

            this.openedWith = this.currentChoice();
        },

        rangeDaysLetters() {
            return RANGE_DAYS.filter(day => this.rangeDaysOfWeek[day[0]]).map(day => day[1]);
        },

        currentChoice() {
            return {
                options: this.sortedRequestedTimestamps.join(','),
                range: [this.rangeStart || '', this.rangeEnd || '', this.rangeDaysLetters().join('')].join('|'),
            };
        },

        redrawRangePickers() {
            if (this.$refs.DatePickerStart)
                this.$refs.DatePickerStart.redraw();
            if (this.$refs.DatePickerEnd)
                this.$refs.DatePickerEnd.redraw();
        },


        // tab 2 / 3 is applied only when it changed since the modal opened: a look at a tab (or an empty
        // one) leaves the event's date as it is. Tab 1 applies on the click.
        emitDates() {

            let now = this.currentChoice();
            let openedWith = this.openedWith || {};

            if (this.activeTab == 2) {

                if (now.options == openedWith.options)
                    return;

                this.$emit('multipleOptions', this.sortedRequestedTimestamps.map(t => new Date(t)));

            } else if (this.activeTab == 3) {

                if (!this.rangeStart || now.range == openedWith.range)
                    return;

                this.$emit('dateRange', this.rangeStart, this.rangeEnd, this.rangeDaysLetters());

            }

        },

        openModal() {
            this.$refs.singleDateCalendar.setMonthView();
            this.loadOptionDates();
            this.$refs.EventDatePickerModal.show();
        },
        closeModal() {
            this.$refs.EventDatePickerModal.hide();
        },
        setActiveTab(i) {
            this.activeTab = i;
        },
        save() {

        }

    },
    components: { DatePicker, Calendar, PlanupCalendar }
}
</script>
<style>
.edpChosenDates {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-top: 10px;
    text-align: right;
}

.edpChosenDate {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 3px 10px;
    border-radius: 14px;
    background: #f1ecfd;
    color: #6d5bd0;
    font-size: 13px;
    cursor: pointer;
}

.edpChosenDate:hover {
    background: #e9e0fb;
}

.edpChosenDate i {
    color: #999;
}

.edpChosenDate i:hover {
    color: #555;
}

/* the options / range under the field, while the event has no date */
.edpRequested {
    margin-top: 5px;
    font-size: 12.5px;
    line-height: 18px;
    color: #6d5bd0;
    cursor: pointer;
}

.edpRequested i {
    margin-left: 3px;
}

/* tabs 2 / 3 of an event that has a date */
.edpNote {
    text-align: right;
    margin: -4px 0 12px;
    padding: 6px 12px;
    border-radius: 6px;
    background: #fff6e8;
    color: #9a6400;
    font-size: 13px;
}
</style>